// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"d420b6be","603":"352b72f0"}[chunkId] + ".chunk.js";
};